import * as types from 'features/auth/redux/types';
import { RegistrationInput, UserLoginData } from 'features/auth/ts';
import { Nullable } from 'ts';

export const registerUserRequest = (data: RegistrationInput) => ({
  type: types.REGISTER_USER_REQUEST,
  payload: { ...data },
});

export const registerUserSuccess = () => ({
  type: types.REGISTER_USER_SUCCESS,
});

export const registerUserFailed = (error: Nullable<string> | Record<string, unknown[]>) => ({
  type: types.REGISTER_USER_FAILED,
  payload: {
    error,
  },
});

export const loginRequest = (email: string, password: string, successCallback: () => void) => ({
  type: types.LOGIN_REQUEST,
  payload: {
    email,
    password,
    successCallback,
  },
});

export const loginSuccess = (user: UserLoginData, isFirstLogin: boolean) => ({
  type: types.LOGIN_SUCCESS,
  payload: {
    user,
    isFirstLogin,
  },
});

export const loginFailed = (error: Nullable<string>) => ({
  type: types.LOGIN_FAILED,
  payload: {
    error,
  },
});

export const loginByVerificationCodeRequest = (token: string) => ({
  type: types.LOGIN_BY_VERIFICATION_CODE_REQUEST,
  payload: { token },
});

export const loginByVerificationCodeSuccess = (user: UserLoginData, isFirstLogin: boolean) => ({
  type: types.LOGIN_BY_VERIFICATION_CODE_SUCCESS,
  payload: { user, isFirstLogin },
});

export const loginByVerificationCodeFailed = (error: Nullable<string>) => ({
  type: types.LOGIN_BY_VERIFICATION_CODE_FAILED,
  payload: { error },
});

export const autologinRequest = (autologin_token: string) => ({
  type: types.AUTO_LOGIN_REQUEST,
  payload: {
    autologin_token,
  },
});

export const autologinSuccess = (user: UserLoginData, isFirstLogin: boolean) => ({
  type: types.LOGIN_SUCCESS,
  payload: {
    user,
    isFirstLogin,
  },
});

export const autologinFailed = (error: Nullable<string>) => ({
  type: types.LOGIN_FAILED,
  payload: {
    error,
  },
});

export const logoutRequest = () => ({
  type: types.LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS,
});

export const logoutFailed = (error: Nullable<string>) => ({
  type: types.LOGOUT_FAILED,
  payload: {
    error,
  },
});

export const resetPasswordRequest = (email: string) => ({
  type: types.RESET_PASSWORD_REQUEST,
  payload: {
    email,
  },
});

export const resetPasswordSuccess = () => ({
  type: types.RESET_PASSWORD_SUCCESS,
});

export const resetPasswordFailed = (error: Nullable<string>) => ({
  type: types.RESET_PASSWORD_FAILED,
  payload: {
    error,
  },
});

export const confirmResetPasswordRequest = (token: string, new_password: string) => ({
  type: types.CONFIRM_RESET_PASSWORD_REQUEST,
  payload: {
    token,
    new_password,
  },
});

export const confirmResetPasswordSuccess = () => ({
  type: types.CONFIRM_RESET_PASSWORD_SUCCESS,
});

export const confirmResetPasswordFailed = (error: Nullable<string>) => ({
  type: types.CONFIRM_RESET_PASSWORD_FAILED,
  payload: {
    error,
  },
});

export const confirmRegistrationRequest = (token: string, new_password: string) => ({
  type: types.CONFIRM_REGISTRATION_REQUEST,
  payload: {
    token,
    new_password,
  },
});

export const confirmRegistrationSuccess = () => ({
  type: types.CONFIRM_REGISTRATION_SUCCESS,
});

export const confirmRegistrationFailed = (error: Nullable<string>) => ({
  type: types.CONFIRM_REGISTRATION_FAILED,
  payload: {
    error,
  },
});

export const uploadVerificationDocumentsRequest = (personal_id: File, trade_license: File) => ({
  type: types.UPLOAD_VERIFICATION_DOCUMENTS_REQUEST,
  payload: {
    personal_id,
    trade_license,
  },
});

export const uploadVerificationDocumentsSuccess = () => ({
  type: types.UPLOAD_VERIFICATION_DOCUMENTS_SUCCESS,
});

export const uploadVerificationDocumentsFailed = (error: Nullable<string>) => ({
  type: types.UPLOAD_VERIFICATION_DOCUMENTS_FAILED,
  payload: {
    error,
  },
});

export const showUploadVerificationDocumentsModal = (reUpload = false) => ({
  type: types.SHOW_UPLOAD_VERIFICATION_DOCUMENTS_MODAL,
  payload: {
    reUpload,
  },
});

export const hideUploadVerificationDocumentsModal = () => ({
  type: types.HIDE_UPLOAD_VERIFICATION_DOCUMENTS_MODAL,
});

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});

export type AuthActions = ReturnType<
  | typeof registerUserRequest
  | typeof registerUserSuccess
  | typeof registerUserFailed
  | typeof loginRequest
  | typeof autologinRequest
  | typeof autologinSuccess
  | typeof autologinFailed
  | typeof loginSuccess
  | typeof loginFailed
  | typeof loginByVerificationCodeRequest
  | typeof loginByVerificationCodeSuccess
  | typeof loginByVerificationCodeFailed
  | typeof clearError
  | typeof logoutRequest
  | typeof logoutSuccess
  | typeof resetPasswordRequest
  | typeof resetPasswordSuccess
  | typeof resetPasswordFailed
  | typeof logoutFailed
  | typeof confirmResetPasswordRequest
  | typeof confirmResetPasswordSuccess
  | typeof confirmResetPasswordFailed
  | typeof confirmRegistrationRequest
  | typeof confirmRegistrationSuccess
  | typeof confirmRegistrationFailed
  | typeof uploadVerificationDocumentsRequest
  | typeof uploadVerificationDocumentsSuccess
  | typeof uploadVerificationDocumentsFailed
  | typeof showUploadVerificationDocumentsModal
  | typeof hideUploadVerificationDocumentsModal
>;
